// extracted by mini-css-extract-plugin
export default {"header_tittle":"Index_header_tittle__-W8Rt","button":"Index_button__Y4T2y","text":"Index_text__Smgel","content":"Index_content__u0kSZ"};